// extracted by mini-css-extract-plugin
export default {"root":"t8OdNPsyNIKViYnUNvPC","wrap":"ynmK6xxS8UJKFCPQrLR7","query":"buXAV3s0qHvFTybc1ZOs","clicker":"O6vnroPj0TRi43NQf6xv"};